export const getUserLevel = (profile) => parseInt(profile.plan.slice(-1));
